<template>
  <div class="orderPage">
    <div class="tit flex-rowl">
      <p>{{ dataInfo.datestr }}</p>
      <p>{{ dataInfo.shop_name }}</p>
    </div>
    <div class="state_wrap">
      <p>取餐状态：{{dataInfo.getsum}} / {{ dataInfo.ordercount }}</p>
    </div>
    <div class="screen_wrap flex-between">
      <van-radio-group v-model="params.isget" class="flex-rowl" @change="changeRadio">
        <van-radio name="">全部</van-radio>
        <van-radio name="0">只看未取</van-radio>
        <van-radio name="1">只看已取</van-radio>
      </van-radio-group>
    </div>

    <div class="order_wrap">
      <!-- <div class="head flex-between">
          <p class="txt1">订单号</p>
          <p class="txt2">取餐状态&取餐人明细</p>
        </div> -->
      <div class="body" @scroll="orderScroll($event)">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="list" v-if="dataList.length > 0">
            <div class="item" v-for="(item, index) in dataList" :key="index">
              <div class="item_main flex-between">
                <p class="txt1 flex-rowl">{{ item.order_id }} <span class="iconfont icon-fuzhi code" :data-clipboard-text="item.order_id"
                  @click="handleCopy()"></span></p>
                <p class="txt2 flex-rowl">{{ item.stateview }}</p>
              </div>
              <div class="item_wrap01 flex-rowl">
                <p>{{ item.truename }}</p>
                <p class="flex-rowl">{{ item.customer_phone }} <a :href="'tel:'+item.customer_phone" class="flex-rowl"><span class="iconfont icon-24gl-phoneLoudspeaker"></span></a></p>
              </div>
              <div class="item_wrap02">
                <p>{{ item.order_content }}</p>
              </div>
              <div class="item_wrap03">
                <p>送餐楼栋：{{ item.buildingidstr }}</p>
                <p>送餐详细地址：{{ item.address_detail }}</p>
              </div>

              <div class="state" :class="{active : item.isget != 1}">{{ item.isget == 1 ? '已取餐' : '未取餐' }}</div>
            </div>
          </div>
          <van-empty
            description="暂无订单"
            v-if="!isLoading && dataList.length == 0"
          />
        </van-pull-refresh>
      </div>
    </div>

    <div class="custom_btn fixd" @click="handleReturn">返回</div>
  </div>
</template>
    
<script>
import { getToken, encryptstringview, getOrderList } from "../../api/api";
import Clipboard from "clipboard";
export default {
  name: "orderDataList",
  data() {
    return {
      userInfo: "",

      dataInfo: "",
      detail: "",

      isLoading: true,
      total: 0,
      dataList: [],

      params: {
        Page: 1,
        token: "",
        PageSize: 20,
        order_id: "",
        service_order_status: "",
        service_order_property: "",
        istoday: 0, // 1 是 0 否
        customer_phone: "",
        shop_name: '',
        isget: '',
        delivery_request_time: '',
      },
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.userInfo = userInfo;
    console.log(this.$route.params.id);

    if (this.$route.params.id) {
      this.encryptstringview(this.$route.params.id, userInfo.openid);
    }
    // this.getToken();
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { data } = JSON.parse(res.jsondata);
        console.log(data,'=====');
        
        this.dataInfo = data;
        this.params.shop_name = data.shop_name
        this.params.delivery_request_time = data.datestr
        this.getToken();
      } else {
        this.$router.back();
      }
    },

    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getOrderList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 
    changeRadio(e) {
      this.params.isget = e
      this.params.Page = 1
      this.dataList = []
      this.getToken()
    },

    // 获取楼栋详情
    getOrderList(isRefresh) {
      let { params } = this;
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderList(params).then((res) => {
        if (res.error_code == 0) {
          if (isRefresh) {
            this.params.Page = 1;
            this.dataList = [];
          }
          this.total = res.data.total;
          this.dataList = this.dataList.concat(...res.data.list);
          this.isLoading = false;
        } else {
          this.dataList = [];
        }

        toast.clear();
      });
    },

    onRefresh() {
      this.params.Page = 1;
      this.getOrderList(true);
    },
    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getOrderList();
        }
      }
    },

    // 返回上一页
    handleReturn() {
      this.$router.back();
    },

    /**
     * 复制功能
     */
     handleCopy() {
      var clipboard = new Clipboard(".code");
      console.log(clipboard, "=====clipboard");
      clipboard.on("success", (e) => {
        console.log("复制成功", e);
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制", e);
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
    <style lang='less' scoped>
.orderPage {
  padding: 50px 0 0;
  box-sizing: border-box;
  .tit {
    width: 710px;
    margin: auto;
    font-size: 36px;
    font-weight: bold;
    p {
      margin-right: 30px;
    }
  }
  .state_wrap {
    padding: 30px 20px;
    font-size: 28px;
    color: red;
    box-sizing: border-box;
  }
  .screen_wrap {
    padding: 0 20px 50px;
    font-size: 24px;
    box-sizing: border-box;
    .van-radio {
      margin-right: 20px;
    }
  }
  .order_wrap {
    font-size: 30px;
    .head {
      font-weight: bold;
      margin-bottom: 30px;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .body {
      height: 70vh;
      overflow-y: scroll;
      padding-bottom: 100px;
      box-sizing: border-box;
      .item {
        font-size: 26px;
        padding: 35px 20px;
        box-sizing: border-box;
        position: relative;
        &:nth-child(2n-1) {
          background: #eeeeee;
        }
        .item_main {
          font-size: 28px;

        }
        .item_wrap01 {
          margin: 20px 0;
          p {
            &:last-child {
              margin-left: 40px;
            }
          }
        }
        .item_wrap03 {
          color: red;
          font-size: 22px;
          p {
            margin-top: 20px;
          }
        }
        .state {
          position: absolute;
          right: 40px;
          top: 40px;
          &.active {
            color: red;
          }
        }
        .iconfont {
          margin-left: 20px;
          font-size: 30px;
          color: #0e0e0e;
          font-weight: 500;
        }
      }
    }
    p {
      flex-shrink: 0;
    }
    .txt1 {
      width: 390px;
    }
    .txt2 {
      width: 300px;
      text-align: center;
    }
  }
  .custom_btn {
    &.fixd {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 180px;
    }
  }
}
</style>